import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReportsProgress } from '@/components/Analysis/ReportsRevamped/shared/ReportsProgress';

const SummaryContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    margin: 0,
    minHeight: '40px',
}));

const SummaryStats = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    flex: 1,
    fontSize: '1.4rem',
    lineHeight: '1.5',
});

const StatItem = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
});

const StatLabel = styled('span')(({ theme }) => ({
    color: theme.palette.text.secondary,
    fontWeight: 400,
    fontSize: '1.4rem',
}));

const StatValue = styled('span')(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: '1.4rem',
}));

const ProgressContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
    fontWeight: 500,
    fontSize: '1.4rem',
});

const LoadingSkeleton = styled(Skeleton)({
    width: '100%',
    height: '20px',
});

export interface CalculationData {
    totalBlocks: number;
    selectedBlocks: number;
    ri5Area: number;
    totalArea: number;
    percentage: number;
    hasData: boolean;
}

interface CalculationSummaryProps {
    calculations: CalculationData;
    unit?: string;
    loading?: boolean;
    showProgress?: boolean;
}

export const CalculationSummary: React.FC<CalculationSummaryProps> = ({
    calculations,
    unit = 'ft²',
    loading = false,
    showProgress = true,
}) => {
    const { totalBlocks, selectedBlocks, ri5Area, percentage } = calculations;

    if (loading) {
        return (
            <SummaryContainer>
                <SummaryStats>
                    <StatItem>
                        <LoadingSkeleton variant="text" width={60} />
                        <LoadingSkeleton variant="text" width={40} />
                    </StatItem>
                    <StatItem>
                        <LoadingSkeleton variant="text" width={60} />
                        <LoadingSkeleton variant="text" width={40} />
                    </StatItem>
                    <StatItem>
                        <LoadingSkeleton variant="text" width={60} />
                        <LoadingSkeleton variant="text" width={40} />
                    </StatItem>
                </SummaryStats>
                {showProgress && (
                    <ProgressContainer>
                        <LoadingSkeleton variant="circular" width={32} height={32} />
                    </ProgressContainer>
                )}
            </SummaryContainer>
        );
    }

    return (
        
        <SummaryContainer>
            <SummaryStats>
                <StatItem>
                    <StatLabel>Blocks: </StatLabel>
                    <StatValue>{`${selectedBlocks}/${totalBlocks}`}</StatValue>
                </StatItem>
                <StatItem>
                    <StatLabel>Ri5:</StatLabel>
                    <StatValue>{`${ri5Area.toFixed(0)} ${unit}`}</StatValue>
                </StatItem>
                {showProgress && (
                <ProgressContainer>
                    <ReportsProgress progress={percentage} />
                </ProgressContainer>
            )}
            </SummaryStats>

            
        </SummaryContainer>
    );
};